import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
/** Styles Import */
import "./Style.css";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
import TranslationService from "../../Services/Translation/TranslationService";
/** Components Import */
import Loading from "../../Components/Loading";
import { Image } from "react-bootstrap";
import Swal from "../../Components/SweetAlert2";
import SignatureCanvas from "react-signature-canvas";
import AutoTranslate from "../../Components/AutoTranslate";
/** Icons Import */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCircle, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

function Constructions() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [customList, setCustomList] = useState([]);
  const language = useSelector((state) => state.localStorage.language);
  const authorization = useSelector((state) => state.localStorage.authorization);

  // 현재 선택된 작업 인덱스
  const [selectedJobIndex, setSelectedJobIndex] = useState(0);
  const [bookDataList, setBookDataList] = useState([]);

  // 싸인 모달 상태
  const [showSignModal, setShowSignModal] = useState(false);
  const [signDataUrl, setSignDataUrl] = useState(null);
  const signPadRef = useRef(null);

  // 파일 업로드 중 상태
  const [isUploadingFile, setIsUploadingFile] = useState(false);

  useEffect(() => {
    console.log("location.state: ", location.state);
    Init();
  }, []);

  useEffect(() => {
    if (!authorization.auth) {
      navigate("/");
    }
  }, [authorization.auth]);

  useEffect(() => {
    if (location.state.isCompleted) {
      return;
    }
    // 모든 탭의 모든 위험 요인이 체크되었는지 확인
    const allTabsCompleted =
      customList.length > 0 &&
      customList.every((job) => {
        if (!job.riskFactors) return false;
        return job.riskFactors.every((factor) => {
          return factor.allChecked === true || !factor.items || factor.items.length === 0;
        });
      });

    console.log("모든 탭 완료 상태:", allTabsCompleted); // 디버깅용

    if (allTabsCompleted) {
      console.log("모든 탭이 완료되어 싸인 모달을 띄웁니다."); // 디버깅용
      setShowSignModal(true);
    }
  }, [customList, location.state.isCompleted]);

  const Init = async () => {
    try {
      const userData = await IndexedDb.GetUserInfo();
      console.log("userData: ", userData);
      setUserInfo(userData);
      await Search(userData);
    } catch (e) {
      console.log("Init Error: ", e);
    }
  };

  useEffect(() => {
    if (showSignModal && signPadRef.current) {
      const signaturePad = signPadRef.current.getSignaturePad();
      signaturePad.minWidth = 4.5; // 최소 굵기
      signaturePad.maxWidth = 4.5; // 최대 굵기
      const existingSignatureUrl = customList[0]?.signatureUrl;
      if (existingSignatureUrl) {
        signPadRef.current.fromDataURL(existingSignatureUrl);
      } else {
        signPadRef.current.clear();
      }
    }
  }, [showSignModal, customList]);

  const Search = async (_param = userInfo) => {
    try {
      setLoading(true);
      const response = await Commons.Axios("get", Global.base.useUrl + Global.urls.RiskFactor.SearchByEmployee, {
        empId: _param.userId,
        eduId: location.state.site.id,
      });
      console.log("Search response: ", response);
      if (response.status === 200) {
        if (!response.data.items || response.data.items.length < 1) {
          throw new Error("조회된 데이터가 없습니다.");
        } else {
          const data = response.data;
          let _customList = [];
          let _bookDataList = [];
          if (Array.isArray(data.items)) {
            data.items.forEach((item) => {
              if (item.customized) {
                _customList.push(item.customized);
                if (Array.isArray(item.customized.riskFactors)) {
                  _bookDataList.push(item.customized);
                  item.customized.riskFactors.forEach((item1) => {
                    if (Array.isArray(item1.items) && item1.items.length > 0) {
                      // isCompleted에 따라 checked 값 세팅
                      const checkedValue = location.state.isCompleted ? true : false;
                      item1.items = item1.items.map((it) => ({ ...it, checked: checkedValue }));
                      _bookDataList.push({ ...item1, allChecked: checkedValue, isRiskFactor: true });
                    }
                  });
                }
              }
            });
            console.log("customList: ", _customList);
            setCustomList(_customList);
            console.log("bookDataList: ", _bookDataList);
            setBookDataList(_bookDataList);
          }
        }
      } else {
        throw new Error(JSON.stringify(response));
      }
    } catch (e) {
      console.log("Search Error: ", e);
    } finally {
      setLoading(false);
    }
  };

  // 싸인 완료 시
  const handleSignComplete = async () => {
    if (!signPadRef.current) return;
    // 빈 서명 방지
    try {
      if (typeof signPadRef.current.isEmpty === "function" && signPadRef.current.isEmpty()) {
        if (typeof Swal !== "undefined" && Swal.warning) {
          await Swal.warning("서명을 입력해주세요.");
        }
        return;
      }
    } catch (_) {}
    setIsUploadingFile(true);
    try {
      const dataUrl = signPadRef.current.getCanvas().toDataURL("image/png");
      setSignDataUrl(dataUrl);
      setShowSignModal(false);
      // base64 -> Blob 변환
      const byteString = atob(dataUrl.split(",")[1]);
      const mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
      const blob = new Blob([ab], { type: mimeString });
      let formData = new FormData();
      formData.append("file", blob, "sign.png");
      // 싸인 이미지 업로드 (image url이 있으면 쿼리스트링에 추가)
      const baseUploadUrl = Global.base.useUrl + Global.urls.RiskFactor.UploadSign;
      const imageUrl = customList[0]?.image;
      const uploadUrl = imageUrl ? `${baseUploadUrl}?url=${encodeURIComponent(imageUrl)}` : baseUploadUrl;
      const response = await Commons.Axios("postOtherMultipart", uploadUrl, {}, formData);
      const fileUrl = response?.data?.fileUrl;
      if (!fileUrl) throw new Error("서버에서 fileUrl을 받지 못했습니다.");
      await Submit(fileUrl);
    } catch (e) {
      if (typeof Swal !== "undefined" && Swal.custom) {
        await Swal.custom({
          title: "오류가 발생했습니다",
          text: e.message || "서버와 통신 중 오류가 발생했습니다.",
          icon: "error",
          confirmButtonText: "확인",
        });
      } else {
        alert("오류가 발생했습니다: " + (e.message || "서버와 통신 중 오류가 발생했습니다."));
      }
    } finally {
      setIsUploadingFile(false);
    }
  };

  // 위험성 평가 완료만 담당하는 Submit 함수 (싸인 업로드와 분리)
  const Submit = async (fileUrl = "") => {
    try {
      setLoading(true);
      const id = location.state.site.id;
      const completeUrl = `${Global.base.useUrl + Global.urls.RiskFactor.CompleteRiskFactor}?id=${id}&url=${encodeURIComponent(fileUrl)}`;
      const response = await Commons.Axios("post", completeUrl);
      console.log("[Submit] CompleteRiskFactor 응답", response);
      if (response.status === 200) {
        if (typeof Swal !== "undefined" && Swal.success) {
          await Swal.success(`모든 위험성 평가 항목이 완료되었습니다!`);
        } else {
          alert("모든 위험성 평가 항목이 완료되었습니다!");
        }
        navigate(-1);
      } else {
        throw new Error(JSON.stringify(response));
      }
    } catch (e) {
      console.log("[Submit Error]", e);
      if (typeof Swal !== "undefined" && Swal.custom) {
        await Swal.custom({
          title: "오류가 발생했습니다",
          text: e.message || "서버와 통신 중 오류가 발생했습니다.",
          icon: "error",
          confirmButtonText: "확인",
        });
      } else {
        alert("오류가 발생했습니다: " + (e.message || "서버와 통신 중 오류가 발생했습니다."));
      }
    } finally {
      setLoading(false);
    }
  };

  // 위험도 레벨 클릭 핸들러 수정
  const handleRiskLevelClick = (factorType, itemIndex) => {
    if (location.state.isCompleted) {
      return;
    }

    console.log("클릭됨:", factorType, itemIndex, "현재 탭:", selectedJobIndex); // 디버깅용

    // customList 업데이트 - 현재 선택된 탭의 작업만 업데이트
    setCustomList((prevCustomList) => {
      const newCustomList = JSON.parse(JSON.stringify(prevCustomList)); // 깊은 복사

      // 현재 선택된 작업만 업데이트
      const currentJob = newCustomList[selectedJobIndex];
      if (currentJob && currentJob.riskFactors) {
        const riskFactor = currentJob.riskFactors.find((rf) => rf.type === factorType);
        if (riskFactor && riskFactor.items && itemIndex >= 0 && itemIndex < riskFactor.items.length) {
          // item의 checked 상태 토글
          const targetItem = riskFactor.items[itemIndex];
          if (targetItem) {
            targetItem.checked = !targetItem.checked;
            console.log("상태 변경:", factorType, itemIndex, targetItem.checked); // 디버깅용

            // 모든 item이 checked인지 확인하여 allChecked 갱신
            const allChecked = riskFactor.items.every((item) => item.checked);
            riskFactor.allChecked = allChecked;
            console.log("factor allChecked 업데이트:", riskFactor.type, allChecked); // 디버깅용
          }
        }
      }

      // 업데이트된 데이터로 즉시 체크
      setTimeout(() => {
        checkAndMoveToNextTab(newCustomList);
      }, 50);

      return newCustomList;
    });

    // bookDataList도 동시에 업데이트 - 해당 타입의 모든 항목 업데이트
    setBookDataList((prevBookDataList) => {
      const newBookDataList = JSON.parse(JSON.stringify(prevBookDataList)); // 깊은 복사

      // bookDataList에서 해당 타입의 항목 찾기
      const bookDataItem = newBookDataList.find((item) => item.type === factorType);
      if (bookDataItem && bookDataItem.items && itemIndex >= 0 && itemIndex < bookDataItem.items.length) {
        const bookDataSubItem = bookDataItem.items[itemIndex];
        if (bookDataSubItem) {
          bookDataSubItem.checked = !bookDataSubItem.checked;
          const bookDataAllChecked = bookDataItem.items.every((item) => item.checked);
          bookDataItem.allChecked = bookDataAllChecked;
        }
      }

      return newBookDataList;
    });
  };

  // 현재 탭의 모든 위험 요인이 체크되었는지 확인하고 다음 탭으로 이동
  const checkAndMoveToNextTab = (updatedCustomList = null) => {
    // 업데이트된 데이터가 있으면 사용, 없으면 현재 상태 사용
    const currentCustomList = updatedCustomList || customList;
    const currentJob = currentCustomList[selectedJobIndex];

    if (!currentJob || !currentJob.riskFactors) return;

    console.log("현재 탭 체크:", selectedJobIndex, currentJob.jobName); // 디버깅용

    // 현재 탭의 모든 위험 요인이 체크되었는지 확인
    const allFactorsChecked = currentJob.riskFactors.every((factor) => {
      const isChecked = factor.allChecked === true || !factor.items || factor.items.length === 0;
      console.log(`factor ${factor.type}: allChecked = ${isChecked}`); // 디버깅용
      return isChecked;
    });

    console.log("모든 요인 체크됨:", allFactorsChecked); // 디버깅용

    if (allFactorsChecked && selectedJobIndex < currentCustomList.length - 1) {
      console.log("다음 탭으로 이동 시작"); // 디버깅용

      // 다음 탭이 있으면 다음 탭으로 이동
      const nextTabIndex = selectedJobIndex + 1;

      // 화면을 맨 위로 스크롤
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      // 잠시 후 다음 탭으로 이동 (스크롤 애니메이션이 완료된 후)
      setTimeout(() => {
        setSelectedJobIndex(nextTabIndex);

        // 사용자에게 다음 탭으로 이동했다는 알림
        // if (typeof Swal !== "undefined" && Swal.info) {
        //   Swal.info({
        //     title: "완료!",
        //     text: `${currentJob.jobName} 작업의 모든 위험 요인을 확인했습니다. 다음 작업으로 이동합니다.`,
        //     icon: "success",
        //     timer: 2000,
        //     showConfirmButton: false,
        //   });
        // }
      }, 500);
    }
  };

  const handleSignClear = () => {
    if (signPadRef.current) signPadRef.current.clear();
  };

  const allRiskFactorsCheckedNow = React.useMemo(() => {
    // 모든 탭의 모든 위험 요인이 체크되었는지 확인
    if (customList.length === 0) return false;

    return customList.every((job) => {
      if (!job.riskFactors) return false;
      return job.riskFactors.every((factor) => {
        return factor.allChecked === true || !factor.items || factor.items.length === 0;
      });
    });
  }, [customList]);

  // 서명 상태 확인
  const hasSigned = React.useMemo(() => {
    return Boolean((location.state && location.state.isCompleted === true) || customList[0]?.signed === true || customList[0]?.signatureUrl);
  }, [location.state, customList]);

  // 작업 목록에서 작업 선택
  const handleJobSelect = (index) => {
    setSelectedJobIndex(index);
  };

  // 현재 선택된 작업의 위험 요인들 가져오기
  const getCurrentJobRiskFactors = () => {
    if (customList.length === 0) return [];

    // 현재 선택된 작업의 customized 정보에서 riskFactors를 가져옴
    const currentJob = customList[selectedJobIndex];
    if (!currentJob || !currentJob.riskFactors) return [];

    // 현재 작업의 riskFactors만 반환
    return currentJob.riskFactors.filter((factor) => factor.type && Array.isArray(factor.items) && factor.items.length > 0);
  };

  // 전체 진행률 계산 (모든 작업의 모든 위험 요인)
  const getProgressPercentage = () => {
    if (customList.length === 0) return 0;

    let totalItems = 0;
    let checkedItems = 0;

    // 모든 작업의 모든 위험 요인을 합산
    customList.forEach((job) => {
      if (job.riskFactors) {
        job.riskFactors.forEach((factor) => {
          if (factor.items && Array.isArray(factor.items)) {
            totalItems += factor.items.length;
            checkedItems += factor.items.filter((item) => item.checked).length;
          }
        });
      }
    });

    return totalItems > 0 ? Math.round((checkedItems / totalItems) * 100) : 0;
  };

  return (
    <div className='wrapper'>
      {loading && <Loading />}

      {/* 싸인 모달 */}
      {showSignModal && (
        <div
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.4)",
            zIndex: 50000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ background: "#fff", borderRadius: 12, padding: 24, minWidth: 320, boxShadow: "0 2px 16px rgba(0,0,0,0.15)" }}>
            <h3 style={{ marginBottom: 16 }}>
              <AutoTranslate targetLanguage={language.lang}>전자서명(싸인) 입력</AutoTranslate>
            </h3>
            <h5 style={{ marginBottom: 16 }}>
              <AutoTranslate targetLanguage={language.lang}>이름을 정자체로 작성해주세요.</AutoTranslate>
            </h5>
            <SignatureCanvas
              ref={signPadRef}
              penColor='black'
              placeholder={userInfo.userNm}
              canvasProps={{
                width: Commons.IsMobile() ? 320 : 900,
                height: Commons.IsMobile() ? 180 : 400,
                className: "sigCanvas",
                style: { border: "1px solid #aaa", borderRadius: 8, width: Commons.IsMobile() ? 320 : 900, height: Commons.IsMobile() ? 180 : 400 },
              }}
            />
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 16 }}>
              <button onClick={handleSignClear} style={{ padding: "6px 16px", borderRadius: 6, border: "1px solid #aaa", background: "#f8f9fa", fontWeight: 500 }}>
                <AutoTranslate targetLanguage={language.lang}>지우기</AutoTranslate>
              </button>
              <button onClick={() => setShowSignModal(false)} style={{ padding: "6px 16px", borderRadius: 6, border: "1px solid #aaa", background: "#f8f9fa", fontWeight: 500 }}>
                <AutoTranslate targetLanguage={language.lang}>취소</AutoTranslate>
              </button>
              <button
                onClick={handleSignComplete}
                disabled={isUploadingFile}
                style={{
                  padding: "6px 16px",
                  borderRadius: 6,
                  border: "none",
                  background: isUploadingFile ? "#6c757d" : "#198754",
                  color: "#fff",
                  fontWeight: 700,
                  opacity: isUploadingFile ? 0.7 : 1,
                }}
              >
                <AutoTranslate targetLanguage={language.lang}>서명 완료</AutoTranslate>
              </button>
            </div>
          </div>
        </div>
      )}

      <div className='mt-5'>
        {/* 안내 메시지 */}
        <div className='construction-instruction'>
          <div className='construction-instruction-content'>
            <FontAwesomeIcon icon={faExclamationTriangle} className='construction-instruction-icon' />
            <span className='construction-instruction-text'>
              <AutoTranslate targetLanguage={language.lang}>※ 각 요인에 포함된 위험도 레벨(상/중/하)을 클릭하여 모든 내용을 읽고 인지했음을 확인해주세요.</AutoTranslate>
            </span>
          </div>
          <div className='construction-risk-level-legend'>
            <div className='construction-legend-item'>
              <span className='construction-legend-color high'></span>
              <span className='construction-legend-text'>
                <AutoTranslate targetLanguage={language.lang}>상</AutoTranslate>
              </span>
            </div>
            <div className='construction-legend-item'>
              <span className='construction-legend-color medium'></span>
              <span className='construction-legend-text'>
                <AutoTranslate targetLanguage={language.lang}>중</AutoTranslate>
              </span>
            </div>
            <div className='construction-legend-item'>
              <span className='construction-legend-color low'></span>
              <span className='construction-legend-text'>
                <AutoTranslate targetLanguage={language.lang}>하</AutoTranslate>
              </span>
            </div>
          </div>
        </div>
        <div className='construction-container'>
          {/* 헤더 섹션 */}
          <div className='construction-header'>
            <h2 className='construction-title'>
              <AutoTranslate targetLanguage={language.lang}>{location.state.site.siteName}의 위험성 평가</AutoTranslate>
            </h2>
            <p className='construction-subtitle'>
              <AutoTranslate targetLanguage={language.lang}>각 위험 요인을 읽고 이해한 후 체크해주세요</AutoTranslate>
            </p>
          </div>

          {/* 작업 선택 탭 */}
          {customList.length > 0 && (
            <div className='construction-job-tabs'>
              {customList.map((job, index) => {
                // 현재 탭의 모든 위험 요인이 체크되었는지 확인
                const isTabCompleted = job.riskFactors && job.riskFactors.every((factor) => factor.allChecked === true);

                return (
                  <button key={index} className={`construction-job-tab ${selectedJobIndex === index ? "active" : ""} ${isTabCompleted ? "completed" : ""}`} onClick={() => handleJobSelect(index)}>
                    <AutoTranslate targetLanguage={language.lang}>{job.jobName?.endsWith("작업") ? job.jobName : job.jobName + " 작업"}</AutoTranslate>
                    {isTabCompleted && <FontAwesomeIcon icon={faCheckCircle} className='construction-tab-complete-icon' title='완료됨' />}
                  </button>
                );
              })}
            </div>
          )}

          {/* 현재 선택된 작업 정보 */}
          {customList[selectedJobIndex] && (
            <div className='construction-job-info'>
              <div className='construction-job-header'>
                <h3 className='construction-job-name'>
                  <AutoTranslate targetLanguage={language.lang}>
                    {customList[selectedJobIndex].jobName?.endsWith("작업") ? customList[selectedJobIndex].jobName : customList[selectedJobIndex].jobName + " 작업"}
                  </AutoTranslate>
                </h3>
                <div className='construction-job-categories'>
                  <span className='construction-category'>
                    <AutoTranslate targetLanguage={language.lang}>대분류: {customList[selectedJobIndex].largeCategory}</AutoTranslate>
                  </span>
                  <span className='construction-category'>
                    <AutoTranslate targetLanguage={language.lang}>중분류: {customList[selectedJobIndex].mediumCategory}</AutoTranslate>
                  </span>
                </div>
              </div>

              {/* 작업 이미지 */}
              <div className='construction-job-image'>
                <Image
                  src={customList[selectedJobIndex].image ? customList[selectedJobIndex].image : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWCY2m1r8yNTt7x4YzvVf0d9-xJHbgtPmkCw&s"}
                  width={Commons.IsMobile() ? 250 : 400}
                  height={Commons.IsMobile() ? 150 : 200}
                  className='construction-image'
                />
              </div>
            </div>
          )}

          {/* 진행률 표시 */}
          <div className='construction-progress-section'>
            <div className='construction-progress-header'>
              <h4 className='construction-progress-title'>
                <AutoTranslate targetLanguage={language.lang}>전체 위험 요인 인지 진행률</AutoTranslate>
              </h4>
              <span className='construction-progress-percentage'>{getProgressPercentage()}%</span>
            </div>
            <div className='construction-progress-bar'>
              <div className='construction-progress-fill' style={{ width: `${getProgressPercentage()}%` }}></div>
            </div>
          </div>

          {/* 위험 요인 목록 */}
          <div className='construction-risk-factors'>
            {getCurrentJobRiskFactors().map((factor, factorIndex) => (
              <div key={factorIndex} className='construction-risk-factor'>
                <div className='construction-factor-header'>
                  <h5 className='construction-factor-type'>
                    <AutoTranslate targetLanguage={language.lang}>{factor.type}</AutoTranslate>
                  </h5>
                  <div className='construction-factor-status'>
                    {factor.allChecked ? (
                      <FontAwesomeIcon icon={faCheckCircle} className='construction-check-icon checked' />
                    ) : (
                      <FontAwesomeIcon icon={faExclamationTriangle} className='construction-warning-icon' />
                    )}
                  </div>
                </div>

                <div className='construction-factor-items'>
                  {factor.items.map((item, itemIndex) => (
                    <div key={itemIndex} className='construction-factor-item'>
                      <div className='construction-factor-content'>
                        <div className='construction-factor-hazard'>
                          <span className='construction-factor-label'>
                            <AutoTranslate targetLanguage={language.lang}>위험 요인:</AutoTranslate>
                          </span>
                          <span className='construction-factor-text'>
                            <AutoTranslate targetLanguage={language.lang}>{item.hazard}</AutoTranslate>
                          </span>
                        </div>

                        <div className='construction-factor-mitigation'>
                          <span className='construction-factor-label'>
                            <AutoTranslate targetLanguage={language.lang}>개선 대책:</AutoTranslate>
                          </span>
                          <span className='construction-factor-text'>
                            <AutoTranslate targetLanguage={language.lang}>{item.mitigation}</AutoTranslate>
                          </span>
                        </div>
                      </div>

                      <div className='construction-factor-actions'>
                        <div
                          className={`construction-risk-level ${item.checked ? "checked" : ""}`}
                          style={{
                            backgroundColor: item.checked ? (item.riskLevel === "상" ? "#dc3545" : item.riskLevel === "중" ? "#fd7e14" : "#0d6efd") : "#e9ecef",
                          }}
                          onClick={() => handleRiskLevelClick(factor.type, itemIndex)}
                        >
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                            <span style={{ fontSize: "0.8rem", fontWeight: "600", color: "#ffffff" }}>
                              <AutoTranslate targetLanguage={language.lang}>위험성</AutoTranslate>
                            </span>
                            <span className='construction-risk-level-text'>
                              <AutoTranslate targetLanguage={language.lang}>{item.riskLevel}</AutoTranslate>
                            </span>
                          </div>
                          <div style={{ width: "1px", height: "40px", backgroundColor: "#ffffff", opacity: 0.3 }}></div>
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                            <span style={{ fontSize: "0.8rem", fontWeight: "600", color: "#ffffff" }}>
                              <AutoTranslate targetLanguage={language.lang}>가능성</AutoTranslate>
                            </span>
                            <span className='construction-risk-level-text'>
                              <AutoTranslate targetLanguage={language.lang}>{item.riskFrequency ?? "-"}</AutoTranslate>
                            </span>
                          </div>
                          <div style={{ width: "1px", height: "40px", backgroundColor: "#ffffff", opacity: 0.3 }}></div>
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                            <span style={{ fontSize: "0.8rem", fontWeight: "600", color: "#ffffff" }}>
                              <AutoTranslate targetLanguage={language.lang}>중대성</AutoTranslate>
                            </span>
                            <span className='construction-risk-level-text'>
                              <AutoTranslate targetLanguage={language.lang}>{item.riskStrength ?? "-"}</AutoTranslate>
                            </span>
                          </div>
                          {item.checked ? <FontAwesomeIcon icon={faCheckCircle} className='construction-item-check' /> : <FontAwesomeIcon icon={faCircle} className='construction-item-uncheck' />}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* 서명 버튼 */}
          {(location.state?.isCompleted === true || allRiskFactorsCheckedNow) && (
            <div className='construction-sign-section'>
              <button
                type='button'
                className='construction-sign-button'
                onClick={async (e) => {
                  e.stopPropagation();
                  if (hasSigned) {
                    if (typeof Swal !== "undefined" && Swal.info) {
                      await Swal.info("서명 완료", "이미 서명을 하였습니다.");
                    }
                    return;
                  }
                  setShowSignModal(true);
                }}
              >
                <FontAwesomeIcon icon={faCheckCircle} className='construction-sign-icon' />
                <AutoTranslate targetLanguage={language.lang}>서명하기</AutoTranslate>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Constructions;
